import { css } from '@emotion/css';

import { SortMenuProps } from '@/components/SortMenu/types';

export const filterBottomSheetStyles = css`
  .MuiDrawer-paper {
    background-color: var(--bg-primary);
    border-top-left-radius: 1.2rem;
    border-top-right-radius: 1.2rem;
  }

  .drawer-handler {
    margin: 0;
    margin-top: 0.8rem;
  }
`;

export const SORT_MENU_OVERRIDES: SortMenuProps['overrides'] = {
  PopoverContent: {
    classes: {
      BottomSheet: { root: filterBottomSheetStyles },
    },
  },
};
